import ImageWithBadgeBand from '@/components/atoms/image/ImageWithBadgeBand.vue'
import BundleDiscountLabelWithStore from '@/components/molecules/discount/BundleDiscountLabelWithStore.vue'
import ItemRating from '@/components/molecules/item/ItemRating.vue'
import CatalogButton from '@/components/organisms/catalog/CatalogDemand.vue'
import AddToCartButtonInListAdapterForTemplate from '@ajax/vue/components/organisms/addtocart/in-item-list/adapter/AddToCartButtnInListAdapterForTemplate.vue'
import CategoryMenu from '@ajax/vue/components/templates/CategoryMenu.vue'
import GenreMenu from '@ajax/vue/components/templates/GenreMenu.vue'
import { getConditionView } from '@ajax/vue/components/templates/item-list/condition/get-condition-view'
import Itemlist from '@ajax/vue/components/templates/Itemlist.vue'
import Refine from '@ajax/vue/components/templates/Refine.vue'
import SearchArea from '@ajax/vue/components/templates/SearchArea.vue'

export const sideBarComponents = {
  category: CategoryMenu,
  genre: GenreMenu,
  searchArea: SearchArea,
}

/**
 * フリーコンテンツやページリストなどを展開したときに出てくるrouter-viewタグの
 * name プロパティに入る可能性があるコンポーネント。
 * フリーコンテンツやページリストなどを使用するページでは、
 * Vue RouterでfreeContentPageComponentsを適切に設定する必要がある。
 *
 * なお、フリーコンテンツやページリストなどを展開したときに出てくる
 * item-list-price-mpaなどのVueコンポーネントのタグは、
 * global/index.ts でコンポーネントをグローバルに登録して対応する。
 * @see client/src/components/global/index.ts
 */
export const freeContentPageComponents = {
  condition: getConditionView(),
  refine: Refine,
  itemlist: Itemlist,
  image: ImageWithBadgeBand,
  'bundle-discount-label-with-store': BundleDiscountLabelWithStore,
  'catalog-demand': CatalogButton,
  'item-rating': ItemRating,
  'add-to-cart-button-in-list': AddToCartButtonInListAdapterForTemplate,
  ...sideBarComponents,
}
